<html>
<head>
<style>

.mat-dialog-container {
  background: white !important;
  color: black;
}

body{
  background-color: white !important;
  color: black;
  overflow-y: scroll;
}

.custom-tooltip {
  position: absolute;
  z-index: 1000; /* Ensure it's on top */
  width: 100px; /* Adjust as needed */
  top: 100%; /* Adjust as needed */
  left: 0; /* Adjust as needed */
  display: block; /* Hide or show based on condition */
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #54d354;
  animation: spin 1s linear infinite;
  margin: 10px auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>
</head>
<body>
  <div id="imgModal" style= "position: fixed;
    z-index: 1000;
    bottom: 0;
    right: 0;
    background: #ffffffd6;
    width: 500px;
    padding: 1em;
    height: 500px;display:none;">

    <img id="img01" style="width: 100%; height: 100%;" src="" alt="Image">
  </div>
  <div style="display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;">
    <div style=" padding: 10px; align-items: center;text-align: center;">
        <h1 style="font-size:20px;color:#cecece">
            Form Logs
        </h1>
    </div>
    <div id="streetAddressOnly" *ngIf="data.all">
      <p style="text-align: center;
      font-weight: 600;
      color: #5c5c5c;
      font-size: 24px;">{{data.street_address}}</p>
    </div>
    <div id="selectorButtons" *ngIf="data.all" style="width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-bottom: 40px;
      position: sticky;
      top: 15px;
      background: #ffffffa1;
      justify-content: space-evenly;
      align-content: center;">
      <div style="width: 80%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;">
        <!-- Create a button for each unique date -->
        <button *ngFor="let date of getUniqueDates(data.formData)" (click)="selectDate(date)"
        [ngStyle]="date === selectedDate ? {background: '#579d44;'} : {background: '#54d354'}" 
        style="flex: 0 0 20%;
        margin-bottom: 10px;
        border: 0px;
        border-radius: 25px;
        color: white;
        line-height: 16px;
        font-size: 16px;
        font-weight: bold;">
          {{ date | date: 'mediumDate' }}
          <p *ngIf = "findScheduledJob(date).length > 1">{{findScheduledJob(date)}}</p>
          <p *ngIf = "findScheduledJob(date).length > 1">{{findEmployee(date)}}</p>
        </button>
        <button (click)="changeToApplog()"
        style="flex: 0 0 20%;
        margin-bottom: 10px;
        border: 0px;
        border-radius: 25px;
        background: #3e3e3e;
        color: white;
        line-height: 16px;
        font-size: 16px;
        font-weight: bold;">
          <p>App Log Info</p>
        </button>
        <button (click)="showEmailLogs()"
        style="flex: 0 0 20%;
        margin-bottom: 10px;
        border: 0px;
        border-radius: 25px;
        background: #3e3e3e;
        color: white;
        line-height: 16px;
        font-size: 16px;
        font-weight: bold;">
          <p>Results Emails</p>
        </button>
      </div>
    </div>
    <div>
      <p style="margin-top: -15%;
      margin-bottom: 10%;
      color: #767676;">{{jobOutput}}</p>
    </div>
    <div *ngIf="!showApplogData && !showEmailData">
      <input type="text" placeholder="Search" [(ngModel)]="search" (ngModelChange)="applyFilter()" style="width: 100%;">
      <div>
          <div>
            <label style="color: #424242; padding-top: 1em;"><input type="checkbox" (change)="toggleImagePreview()" > Link-Hover Image Preview </label>
          </div>
          <div>
            <label style="color: #424242;"><input type="checkbox" (change)="setFullStory()" >Show full story (incl. duplicate entries)</label>
          </div>
      </div>
    </div>

    <div id="jobInfo" *ngIf="!data.all">
      <p style="text-align: center;
      font-weight: 600;
      color: #5c5c5c;
      font-size: 24px;">{{data.street_address}}</p>
      <p style="text-align: center;
      font-weight: 200;
      line-height: 0.3;
      margin-bottom: 3em;
      color: #505050;"> {{data.customer_name}} {{data.customer_jobtype}}</p>
    </div>

    <div id="logContainer" style="width:90%;" *ngIf="!showApplogData && !showEmailData">
    <!-- Update ngFor to filter based on selectedDate -->
      <div class="d-flex col-lg-6 p-3" *ngFor="let obj of displayedData; let indexOfElement = index; trackBy: trackByFn;" style="padding-bottom:20px;width: 100% !important;">

        <div id='regdiv' *ngIf="!obj.item.includes('_pic')" style="background: white;font-weight: 400;
        letter-spacing: 1px;">
          {{ obj.created_at  | date: 'short' }} :  {{ obj.rater }} changed  <span style="font-size: 15px;">{{ obj.item }}</span> to <span style="color: #54d354; font-size: 15px;">{{ obj.thevalue }}</span>
        </div>
         
         <div id='elevpics' *ngIf="obj.item.includes('_pic') && obj.thevalue.includes('elev')" style="background: white;font-weight: 400;
        letter-spacing: 1px;">
          {{ obj.created_at  | date: 'short' }} :  {{ obj.rater }} changed  <span style="font-size: 15px;">{{ obj.item }}</span> to <a [href]="obj.thevalue" target="_blank" rel="noopener noreferrer">
            <span style="color: #54d354; font-size: 15px;">{{ obj.thevalue }}</span></a>
        </div>
    
        
        <div id='picdiv' *ngIf="obj.item.includes('_pic') && !obj.thevalue.includes('elev') " style="background: white;font-weight: 400;
        letter-spacing: 1px;">
          {{ obj.created_at  | date: 'short' }} :  {{ obj.rater }} changed  <span style="font-size: 15px;">{{ obj.item }}</span> to  <a [href]="'https://inspexn.s3.amazonaws.com/' + obj.thevalue + '.jpg'" target="_blank" rel="noopener noreferrer">
            <span style="color: #54d354; font-size: 15px;">{{ obj.thevalue }}.jpg</span></a>
        </div>

      </div>
    </div>

    <div *ngIf="isApplogDataLoaded" style="text-align: center; margin-top: 20px;">
      <p>Loading...</p>
      <div class="spinner"></div>
    </div>

    <div *ngIf="!isApplogDataLoaded && showApplogData && !showEmailData">
      <div class="d-flex col-lg-6 p-3" *ngFor="let obj of displayedData; let indexOfElement = index; trackBy: trackByFn;" style="padding-bottom:20px;width: 100% !important;">

        <div id='appdiv' style="background: white;font-weight: 400;
        letter-spacing: 1px;">
          <ng-container *ngFor="let part of tripParts(obj.message); let last = last">{{ part }}<b *ngIf="!last">(TRIP)</b></ng-container>
        </div>

      </div>

    </div>

    <div *ngIf="isEmailDataLoaded" style="text-align: center; margin-top: 20px;">
      <p>Loading...</p>
      <div class="spinner"></div>
    </div>

    <div *ngIf="showEmailData && !showApplogData" style="width:85%;">
      <div class="d-flex col-lg-6 p-3" *ngFor="let obj of displayedData; let indexOfElement = index; trackBy: trackByFn;" style="padding-bottom:20px;width: 100% !important;">

        <div id='emaildiv' style="background: white;font-weight: 400;letter-spacing: 1px;">
          <p>{{ obj.message }} </p>
        </div>

      </div>

    </div>


</div>
</body>
</html>
